/**
 * Date formatting utility functions.
 *
 * Centralizes date formatting logic to ensure consistency across all components.
 *
 * @module dateUtils
 */

/**
 * Format a date string or Date object to a localized date and time string
 *
 * @param date - Date to format
 * @returns Formatted date and time string
 *
 * @example
 * ```ts
 * formatDateTime('2024-01-15T10:30:00Z') // "1/15/2024, 10:30:00 AM" (en-US)
 * ```
 */
export const formatDateTime = (date: string | Date): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return dateObj.toLocaleString('en-US');
};

/**
 * Format a date string or Date object to a localized date-only string
 *
 * @param date - Date to format
 * @returns Formatted date string (no time)
 *
 * @example
 * ```ts
 * formatDateOnly('2024-01-15T10:30:00Z') // "1/15/2024" (en-US)
 * ```
 */
export const formatDateOnly = (date: string | Date): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return dateObj.toLocaleDateString('en-US');
};
